"use client"

import * as React from "react"
import { cn } from "@/lib/utils"
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog"

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  children: React.ReactNode
  description?: string
  size?: "sm" | "md" | "lg" | "xl"
}

const sizeMap = {
  sm: "max-w-md",
  md: "max-w-2xl",
  lg: "max-w-4xl",
  xl: "max-w-6xl",
}

export function Modal({ isOpen, onClose, title, children, description, size = "lg" }: ModalProps) {
  return <Dialog open={isOpen} onOpenChange={open => { if (!open) onClose() }}>
    <DialogContent {...(!description ? { "aria-describedby": undefined } : {})} className={cn("flex max-h-[90dvh] flex-col gap-0 overflow-hidden rounded-xl p-0", sizeMap[size])}>
      <DialogHeader className="shrink-0 border-b px-6 py-5 pr-14">
        <DialogTitle>{title}</DialogTitle>
        {description && <DialogDescription>{description}</DialogDescription>}
      </DialogHeader>
      <div className="min-h-0 flex-1 overflow-y-auto p-6">{children}</div>
    </DialogContent>
  </Dialog>
}
